import { ModalDelete } from "expano-components";
import { deleteWarehouse } from "actions/warehouses";

import { useMainList } from "components/MainList/context/provider";

const ModalDeleteWarehouse = ({ id, name, handleClose }) => {
  const { refetch } = useMainList();

  const onDelete = async () => {
    try {
      await deleteWarehouse(id);
      refetch();
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <ModalDelete
      handleDelete={onDelete}
      handleClose={handleClose}
      name={`magazyn ${name}?`}
    />
  );
};

export default ModalDeleteWarehouse;
